<template>
	<div class="col-lg-8">
		<p><strong>{{ fullName }}</strong></p>
		<h4><strong>Мои обращения</strong></h4>
		<p><b>Полный список.</b><br> </p>
		<div class="convertion__count">
			Всего записей:
			<strong>
				{{ appeals.length }}
			</strong>
		</div>
		<div v-if="appeals.length === 0">
			<b>Нет записей</b>
		</div>
		<template v-else>
			<div class="convertion__elem" v-for="item in appeals" :key="item.uid">
				<AppealItem :item="item" />
			</div>
		</template>

	</div>
</template>

<script>
import { getFullName, getConfig } from '@/auth'
import { getDataWithToken, } from '@/api/getData'
import getStatus from '@/functions/getStatus'
import AppealItem from '@/components/AppealItem.vue'

export default {
	components: {AppealItem},
	data() {
		return {
			fullName: '',
			appeals: [],
		}
	},
	created() {
		this.fullName = getFullName()
		this.getPage()
	},
	methods: {
		getPage: function () {
			let url = getConfig().appealsUserUrl
			getDataWithToken(url).then(x => {
				this.appeals = x.data.map(x => {
					let y = { ...x }
					y.fio = `${x.last_name ?? ''} ${x.first_name ?? ''} ${x.middle_name ?? ''}`
					y.zone_name = x.zone.name
					y.date_ip = new Date(x.date).toLocaleDateString();
					y.eds_date_local = x.eds_date ? new Date(x.eds_date).toLocaleDateString() : '';
					y.status_desc = getStatus(x?.status_type?.msed_id)

					return y
				})
				this.links = x.links
			})
		}
	}
}
</script>